<template>
    <div class="buildingPage">
        <div class="buildingRight">
            <!-- 遮罩层 -->
            <!-- <div v-if="maskOpen" class="mask"></div> -->
            <div class="buildingRight-title">
                <div class="buildlists">
                    <div>{{ $t('buiding.buildingList') }}</div>
                    <div class="buildingAdd" @click="buildingAppend">
                        <div class="addrolesspan">
                            <el-icon size="16" class="addroles">
                                <Plus />
                            </el-icon>
                        </div>
                        <div>{{ $t('buiding.add') }}</div>
                    </div>
                </div>
                <el-tree v-if="current_id" :data="treeData" node-key="id" :current-node-key="current_id" default-expand-all
                    @node-click="handleNodeClick" :expand-on-click-node="true" highlight-current>
                    <template #default="{ node, data }">
                        <div class="custom-tree-node">
                            <!-- 楼层加楼层号 -->
                            <span v-if="data.floorFlag" @mouseenter="visibilityChange($event)">
                                <el-popover v-if="overFlowHidiFlag" placement="top-start" width="300" popper-class='popperClass' trigger="hover"
                                    :content="data.name">
                                    <template #reference>
                                        <span class="spanColor">{{ data.index }}{{ $t('public.layer') }}<span
                                                class="spanColor" style="margin-left:10px;">{{
                                                    data.name }}</span></span>
                                    </template>
                                </el-popover>
                                <span v-else class="spanColor">{{ data.index }}{{ $t('public.layer') }}<span
                                        class="spanColor" style="margin-left:10px;">{{
                                            data.name }}</span></span>
                            </span>
                            <span v-if="data.buildingFlag" @mouseenter="visibilityChange($event)">
                                <img v-if="!data.buildingActive" class="frontPic"
                                    src="../../assets/images/public/building.png">
                                <img v-if="data.buildingActive" class="frontPic"
                                    src="../../assets/images/public/buildingActive.png">
                                <el-popover v-if="overFlowHidiFlag" placement="top-start" popper-class='popperClass' trigger="hover"
                                    :content="data.name" :show-after="500">
                                    <template #reference>
                                        <span class="spanColor">{{ data.name }}</span>
                                    </template>
                                </el-popover>
                                <span v-else class="spanColor">{{ data.name }}</span>
                            </span>
                            <span v-if="data.shopFlag" @mouseenter="visibilityChange($event)">
                                <img v-if="!data.shopChecked" class="frontPic" src="../../assets/images/public/shop.png">
                                <img v-if="data.shopChecked" class="frontPic"
                                    src="../../assets/images/public/shopActive.png">
                                <el-popover v-if="overFlowHidiFlag" placement="top-start" popper-class='popperClass' trigger="hover"
                                    :content="data.name" :show-after="500">
                                    <template #reference>
                                        <span class="spanColor">{{ data.name }}</span>
                                    </template>
                                </el-popover>
                                <span v-else class="spanColor">{{ data.name }}</span>
                            </span>
                            <span class="solt-center">
                                <div v-if="!data.show">
                                    <span class="span1" v-if="data.buildingFlag || data.shopFlag">
                                        <img src="../../assets/images/public/robot.png" @click.stop="jump(data)"><span
                                            class="span-num">{{
                                                data.robot_num
                                            }}</span>
                                    </span>
                                    <!-- <span class="span1" v-if="data.floorFlag"><img
                                            src="../../assets/images/public/map.png"><span class="span-num mapNum">{{ data.map_num }}</span></span> -->
                                    <el-tooltip v-if="data.buildingFlag" class="box-item" effect="light" hide-after="0"
                                        :content="$t('buiding.addFloors')" placement="top">
                                        <span class="span2" @click.stop="append(data)"><img
                                                src="../../assets/images/public/add.png"></span>
                                    </el-tooltip>
                                    <el-popover placement="bottom" popper-class='popperClass' trigger="click">
                                        <span style="height:20px;cursor:pointer;" @click.stop="edit(node, data)">{{
                                            $t('public.rename')
                                        }}</span>
                                        <br>
                                        <div style="height:10px"></div>
                                        <span style="width:40px;cursor:pointer;" @click.stop="remove(node, data)">{{
                                            $t('public.delete')
                                        }}</span>
                                        <template #reference>
                                            <span
                                                :class="{ span4: true, span4_1528_style: span4_1528, span4_1272_style: span4_1272 }">
                                                <el-icon>
                                                    <MoreFilled />
                                                </el-icon>
                                            </span>
                                        </template>
                                    </el-popover>
                                </div>
                            </span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </div>
        <div class="buildingContent" ref="buildingContent">
            <!-- 楼宇无内容显示 -->
            <div v-show="notDataFlag == null">
                <div class="noContent">
                    <img src="../../assets/images/public/noContent.png" />
                    <div>{{ $t('buiding.pleaseCompleteBuidingsData') }}</div>
                </div>
            </div>
            <!-- 选中楼层展示 -->
            <div v-show="notDataFlag == 'floor'">
                <div class="mapinfo">
                    <el-tabs v-model="activeNameCopy" class="demo-tabs">
                        <el-tab-pane :label="$t('buiding.map')" name="tabMap"></el-tab-pane>
                    </el-tabs>
                    <!-- <div v-show="detailmapinfo.length > 0 && tabMapFlag" class="message">
                        <span>来源：</span>{{ mapinfos.nickname }}
                        <span>上传时间：</span>{{ moment(mapinfos.CreatedAt).format('YYYY-MM-DD HH:mm:ss') }}
                        <span class="deletebtn" @click="Deletemapbtn(mapinfos, 'map')">删除</span> 暂时删除
                    </div> -->
                    <div class="cardmap">
                        <div v-for="(item, key) in detailmapinfo" class="cardBox" :key="key">
                        <div class="oneCard"  @click="setmapinfo(item)">
                            <div class="card-header">
                                <span class="mapName" :title="item.map_name">{{ item.map_name }}</span>
                                <span class="deletebtn" @click.stop="Deletemapbtn(item.map_id, 'map', 'build')">{{
                                    $t('public.delete')
                                }}</span>
                            </div>
                            <div class="card-body">
                                <div class="textdiv"><span>{{ $t('buiding.source') }}：</span><span>{{
                                    item.nickname ?
                                    item.nickname : item.robot_sn
                                }}</span></div>
                                <div class="textdiv">
                                    <span>{{ $t('buiding.uploadTime') }}：</span><span>{{
                                        moment(item.upload_time *
                                            1000).format(momentStamp('dateTime'))
                                    }}</span>
                                </div>
                            </div>
                            <div class="card-footer">
                                <img :src="item.png_url ? item.png_url : 'data:image/png;base64,' + item.png_map" alt="">
                            </div>
                        </div>
                    </div>
                    </div>
                    <el-pagination v-show="total > 0" :background="true" :page-size="mappamrs.pageSize" :total="total"
                        :current-page="mappamrs.page" :page-sizes="[12, 24, 48]" @current-change="buildhandleCurrentChange"
                        @size-change="buildhandleSizeChange" layout="total, prev, pager, next, sizes" class="pagination" />
                    <div class="noContent notData" v-if="detailmapinfo.length == 0 && tabMapFlag">
                        <img src="../../assets/images/public/notData.png" />
                        <div>{{ $t('system.noData') }}</div>
                        <div class="addRobot">{{ $t('buiding.pleaseRobotUploadMap') }}</div>
                    </div>
                </div>
            </div>
            <!-- 选中楼宇展示 -->


            <!-- 选中店铺展示 -->
            <div v-show="notDataFlag == 'shop'" class="relationRobot">
                <el-tabs v-model="activeNameShop" class="demo-tabs">
                    <el-tab-pane :label="$t('buiding.map')" name="shopMap"></el-tab-pane>
                </el-tabs>
                <div class="cardmap">
                <div v-for="(item, key) in detailshoplist" class="cardBox" :key="key"
                    v-show="tabMapFlag && detailshoplist.length > 0" >
                    <div class="oneCard" @click="setmapinfo(item)">
                        <div class="card-header">
                            <span class="mapName" :title="item.map_name">{{ item.map_name }}</span>
                            <span class="deletebtn" @click.stop="Deletemapbtn(item.map_id, 'map', 'shop')">{{
                                $t('public.delete')
                            }}</span>
                        </div>
                        <div class="card-body">
                            <div class="textdiv"><span>{{ $t('buiding.source') }}：</span><span>{{
                                item.nickname ? item.nickname :
                                item.robot_sn
                            }}</span></div>
                            <div class="textdiv">
                                <span>{{ $t('buiding.uploadTime') }}：</span><span>{{
                                    moment(item.upload_time *
                                        1000).format(momentStamp('dateTime'))
                                }}</span>
                            </div>
                        </div>
                        <div class="card-footer">
                            <img :src="item.png_url ? item.png_url : 'data:image/png;base64,' + item.png_map" alt="">
                        </div>
                    </div>
                </div>
                </div>
                <el-pagination v-show="total > 0" :background="true" :page-size="shoppars.pageSize" :total="total"
                    :current-page="shoppars.page" :page-sizes="[12, 24, 48]" @current-change="shophandleCurrentChange"
                    @size-change="shophandleSizeChange" layout="total, prev, pager, next, sizes" class="pagination" />
                <div class="noContent notData" v-if="detailshoplist.length == 0 && tabMapFlag">
                    <img src="../../assets/images/public/notData.png" />
                    <div>{{ $t('system.noData') }}</div>
                    <div class="addRobot">{{ $t('buiding.pleaseRobotUploadMap') }}</div>
                </div>

            </div>
            <div v-if="mapVisible" class="newmapclass">
                <!-- <MapDetail :mapinfos="mapinfos" width="760" height="660"></MapDetail> -->
                   <MapDetail :mapinfos="mapinfos" :width="canvaswidth" :height="canvasheight" @boxmapfntrue="boxmapfntrue" @colsemaps="colsemaps"></MapDetail>
             </div>
        </div>
        <!-- <el-dialog :title="$t('buiding.map')" v-model="mapVisible" v-if="mapVisible" width="800px" top="5vh" :close-on-press-escape="false" @close="colsemaps">
            <MapDetail :mapinfos="mapinfos" width="760" height="660"></MapDetail>
        </el-dialog> -->
        <!-- 删除地图弹框 -->
        <Newdialog :dialogVisibles="deletemapflage" :detatildata="detatildata" :buttonColor="btnColor"
            :borderColor="dialogTtile" @setdata="setdetatils">
        </Newdialog>
        <!-- 确认弹窗 -->
        <dialogs :dialogVisibles="dialogOpen" :msg="dialogMessage" :title="dialogTtile" @off="OFF" @on="ON"
            :buttonColor="btnColor" :borderColor="dialogTtile" name="footer"></dialogs>
        <!-- 楼栋解绑机器人确认弹窗 -->
        <!-- <dialogs :dialogVisibles="buildingOpen" msg="您确定解绑选中的机器人？" title="解绑机器人" @off="buildingOff" @on="buildingOn"
            :buttonColor="btnColor" :borderColor="dialogTtile" name="footer"></dialogs> -->
        <!-- 店铺解绑机器人确认弹窗 -->
        <!-- <dialogs :dialogVisibles="shopOpen" msg="您确定解绑选中的机器人？" title="解绑机器人" @off="shopOff" @on="shopOn"
            :buttonColor="btnColor" :borderColor="dialogTtile" name="footer"></dialogs> -->
        <!-- 关联 更新机器人弹窗  关联梯控弹窗 -->
        <!-- <el-dialog v-model="dialogRobot" :title="dialogRobotTitle" width="30%" :before-close="handleClose"
            :close-on-click-modal="false">
            <el-form v-if="activeName != 'tabLadderControl'" :model="form" :rules="rules" label-width="120px">
                <div class="select-tips" v-if="selectTipsFlag">{{ $t('buiding.associatedBuildings') }}：{{
                    onClickData.name
                }}{{ $t('buiding.door') }}</div>
                <div class="select-box">
                    <el-form-item v-if="relationDialogFlag" :label="$t('buiding.robot')" prop="selectRules">
                        <el-select v-model="form.region" @change="selcetChange" multiple clearable collapse-tags
                            style="width: 240px" :placeholder="placeholderS">
                            <el-option v-for="item in options" :key="item.id"
                                :label="item.nick_name ? item.nick_name : item.sn" :value="item.id"
                                :disabled="item.disabled" />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-else :label="$t('route.building')" prop="selectRules">
                        <el-select v-model="form.region" @change="singleSelcetChange" clearable style="width: 240px"
                            :placeholder="placeholderS">
                            <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogRobot = false">{{ $t('disinfect.canceled') }}</el-button>
                    <el-button type="primary" @click="relationConfirm">{{ $t('robot.confirm') }}</el-button>
                </span>
            </template>
        </el-dialog> -->
        <!-- 店铺关联机器人弹窗 -->
        <!-- <el-dialog v-model="dialogShop" :title="$t('buiding.associatedRobot')" width="30%" :before-close="shopClose"
            :close-on-click-modal="false">
            <el-form v-if="activeName != 'tabLadderControl'" :model="form" :rules="rules" label-width="120px">
                <div class="select-tips" v-if="relationShop">{{ $t('buiding.associatedShop') }}：{{ onClickData.name }}
                </div>
                <div class="select-box">
                    <el-form-item v-if="relationShop" :label="$t('buiding.robot')" prop="selectRules">
                        <el-select v-model="shopForm.shop" @change="robotChange" multiple clearable collapse-tags
                            style="width: 240px" :placeholder="$t('account.PleaseRobots')">
                            <el-option v-for="item in shopOptions" :key="item.id"
                                :label="item.nick_name ? item.nick_name : item.sn" :value="item.id"
                                :disabled="item.disabled" />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-else :label="$t('route.building')" prop="selectRules">
                        <el-select v-model="shopForm.shop" @change="shopChange" clearable style="width: 240px"
                            :placeholder="$t('account.selectbuild')">
                            <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogShop = false">{{ $t('disinfect.canceled') }}</el-button>
                    <el-button type="primary" @click="shopRelationConfirm">{{ $t('robot.confirm') }}</el-button>
                </span>
            </template>
        </el-dialog> -->
        <!-- 添加楼宇楼层 编辑楼宇楼层弹窗 -->
        <el-dialog v-model="buidingDialog" :title="buidingDialogTitle" width="38%" destroy-on-close
            :before-close="buidingDialogClose" :close-on-click-modal="false">
            <el-form :model="buidingDialogForm" :rules="buidingDialogRules" >
                <!-- 添加楼宇展示 -->
                <div v-if="addBuildingFlag">
                    <div class="select-box inputWidth">
                        <el-form-item :label="$t('buiding.type')">
                            <el-select style="width:300px" v-model="buidingDialogForm.selectValue" @change="shopSelect" clearable
                                :placeholder="$t('buiding.pleaseType')">
                                <el-option v-for="item in buidingDialogForm.select" :key="item.value" :label="item.name"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="select-box inputWidth" v-if="buidingDialogForm.selectValue == '0'">
                        <el-form-item :label="$t('buiding.buildingName')" prop="buildingName">
                            <el-input v-model="buidingDialogForm.name" maxlength="20"
                                :placeholder="$t('buiding.pleaseBuildingName')" @change="buildingsChage" @input="buildingsInput" />
                        </el-form-item>
                    </div>
                    <div class="select-box inputWidth" v-if="buidingDialogForm.selectValue == '1'">
                        <el-form-item :label="$t('buiding.shopName')" prop="shopName">
                            <el-input v-model="buidingDialogForm.name" maxlength="20"
                                :placeholder="$t('buiding.pleaseShopName')" @change="buildingsChage" @input="buildingsInput" />  
                        </el-form-item>
                    </div>
                </div>
                <!-- 编辑 -->
                <div v-if="!addBuildingFlag">
                    <div class="select-box inputWidth">
                        <el-form-item :label="inputLabel" :prop="editNameChange">
                            <el-input v-model="buidingDialogForm.name" maxlength="20" :placeholder="addEditHolder" @change="buildingsChage" @input="buildingsInput" />
                        </el-form-item>
                    </div>
                    <div class="select-box inputWidth">
                        <el-form-item v-if="inputNumberFlag" :label="$t('buiding.floor')" prop="id">
                            <el-input-number :min="-99" :max="99" v-model="buidingDialogForm.id" />
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="buidingDialog = false">{{ $t('disinfect.canceled') }}</el-button>
                    <el-button v-if="buidingDialogForm.name == '' || buidingDialogForm.id == ''" type="primary" disabled>{{
                        $t('robot.confirm') }}</el-button>
                    <el-button v-else type="primary" @click="addAndEdit">{{ $t('robot.confirm') }}</el-button>
                </span>
            </template>
        </el-dialog>
             <div v-if="boxmaps" class="newboxmapclass" ref="newboxmapclass">
                   <Boxmapdetail :mapinfos="mapinfos" :width="canvasboxwidth" :height="canvasboxheight" @boxmapfnfalse="boxmapfnfalse"></Boxmapdetail>
             </div>
    </div>
</template>

<script>
import { reactive, ref, toRefs, defineComponent, onMounted, onUnmounted, watch, onBeforeUnmount, } from "vue";
import { robotsSearch } from "@/apis/robot";
import {
    buildingListRequest, getmaplists, buildingAdd, buildingPut, buildingDelete, buildingFloorRequest,
    buildingFloorAdd, buildingFloorDelete, buildingFloorPut, buildingRobotsAll, relationRobots, shopQuery,
    shopUpdate, shopAdd, shopDelete, getshopmaplists, shopRobotUpdate, buildingRobotDelete, shopRobotDelete
} from '@/apis/building'
import { ElMessage, Dialogs } from "element-plus";
import dialogs from '@/components/dialogs/dialogs.vue'
import Newdialog from '@/components/newdialog/Dialog.vue'
import MapDetail from './Mapdetail.vue'
import Boxmapdetail from './boxmapdetai.vue'
import LadderControl from './ladderControl.vue'
import AccessControl from './accessControl.vue'
import { nextTick } from 'process';
import moment from 'moment'
import { momentStamp } from '@/utils/robot'
import paging from '@/components/paging/paging.vue'
import { useRouter } from "vue-router";
import i18n from "@/locales/index";
const _t = i18n.global.t;
import { inputRules,inputLengthLimit } from '@/utils/validate'

export default defineComponent({
    components: {
        dialogs,
        MapDetail,
        Newdialog,
        LadderControl,
        AccessControl,
        paging,
        Boxmapdetail
    },
    setup() {
        // 为空校验
        const buildingName_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.pleaseBuildingName')))
            } else {
                callback()
            }
        }
        const shopName_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.pleaseShopName')))
            } else {
                callback()
            }
        }
        const floorName_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.new-pleaseFloorName')))
            } else {
                callback()
            }
        }
        const buildingEidt_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.pleaseBuildingName')))
            } else {
                callback()
            }
        }
        const floorEidt_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.new-pleaseFloorName')))
            } else {
                callback()
            }
        }
        const shopEidt_validate = (rule, value, callback) => {
            if (state.buidingDialogForm.name === '') {
                callback(new Error(_t('buiding.pleaseShopName')))
            } else {
                callback()
            }
        }

        const inpt = ref(null);
        const router = useRouter();
        const state = reactive({
            notRepeatedClicks: '',
            span4_1528: false,
            span4_1272: false,
            width: document.body.clientWidth,
            activeNameShop: '',
            current_id: '',
            editNameChange: '',
            buildingOpen: false,
            shopOpen: false,
            dialogShop: false,
            relationShop: false,
            params: {
                building_id: '',
                shop_id: '',
                pageSize: 12,
                page: 1,
                limit: true
            },
            inputNumberFlag: false,
            floorLists: {},
            total: 0,
            data: [],
            orderNumberFlag: '',  // 序号显示隐藏
            robotState: '', // 在线 离线
            stateContent: '工作中', // 工作中、空闲、充电等状态
            stateColorOne: 'rgba(82, 196, 26, 0.15)', // 在线状态背景颜色
            stateBorderColorOne: '1px solid #52C41A', // 在线状态边框颜色
            stateSizeColorOne: '#52C41A',  // 在线状态字体颜色
            stateSizeColorTwo: '#1890FF', // 工作中、空闲、充电等状态字体颜色
            stateColorTwo: 'rgba(24, 144, 255, 0.15)', // 工作中、空闲、充电等状态背景颜色
            stateBorderColorTwo: '1px solid #1890FF', // 工作中、空闲、充电等状态边框颜色
            updateActiveFlag: false,
            // BackGroundcolor: '#52C41A', // 电池颜色
            // Batterys: ,       // 充电状态下电量百分比
            chargeshow: false, // 表示是否显示充电图标
            batteryshow: true, //表示当前能获取到电池状态
            relationParams: {     // 关联机器人和更换楼宇上送参数
                building_id: '',
                robots: ''
            },
            shopRelationParams: {     // 关联机器人和更换店铺上送参数
                shop_id: '',
                robots: ''
            },
            relationDialogFlag: true, // true = 关联机器人选择器 false = 更新楼宇选择器
            checked: false,
            relationListArr: '', // 关联机器人数组
            updateBuildingId: '',
            updateData: '',
            numbers: '',
            notDataFlag: null,
            mapfalge: false,
            detailmapinfo: [],
            detailshoplist: [],
            mapinfos: '',
            deletemapflage: false,
            detatildata: {
                id: ''
            },
            treeData: [
            ],
            addData: '',
            maskOpen: false, // 遮罩层
            onClickData: '',
            newChild: '',
            counter: 0,
            removeData: '',
            removeNode: '',
            editData: '',
            editNode: '',
            recordroomid: '',
            event: '',
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            // 确认弹窗
            dialogOpen: false,
            dialogMessage: '',
            dialogTtile: '',
            btnColor: '#F5222D',
            borColor: '#F5222D',
            // 关联 更新机器人弹窗
            upadteContentFlag: false,
            upadteShopFlag: false,
            dialogRobot: false,
            selectTipsFlag: true,
            dialogRobotTitle: '关联机器人',
            placeholderS: '选中机器人',
            labelText: '',
            tabRobotFlag: true,  // tab切换  默认机器人
            tabLadderControlFlag: false, // tab切换 梯控开关
            tabMapFlag: true, // tab切换  默认地图
            tabAccessControlFlag: false,  // tab切换  门禁开关
            activeName: '',
            activeNameCopy: '',
            buidingDialog: false, // 楼宇楼层弹窗
            buidingDialogTitle: '',
            inputLabel: '',
            confirmFlag: '',  // 添加楼宇楼层 | 编辑楼宇楼层标识
            addBuildingFlag: false, // 添加楼宇标识
            // shop_building_Flag: '0', // 店铺和楼栋标识
            addEditHolder: '',
            mapVisible: false,
            buidingDialogForm: {
                selectValue: '',
                select: [
                    // {
                    //     name: _t('buiding.buid-illustrate'),
                    //     value: '0'
                    // },
                    {
                        name: _t('buiding.shop-illustrate'),
                        value: '1'
                    }
                ],
                name: '',
                id: 1
            },
            buidingDialogRules: {
                buildingName: [{ validator: buildingName_validate, trigger: 'blur', }],
                floorName: [{ validator: floorName_validate, trigger: 'blur', }],
                shopName: [{ validator: shopName_validate, trigger: 'blur', }],
                buildingEidt: [{ validator: buildingEidt_validate, trigger: 'blur', }],
                floorEidt: [{ validator: floorEidt_validate, trigger: 'blur', }],
                shopEidt: [{ validator: shopEidt_validate, trigger: 'blur', }],
                id: [{ required: true, message: _t('buiding.serialNumberCannotBeEmpty'), trigger: 'blur', }]
            },
            form: {
                region: '',
            },
            shopForm: {
                shop: '',
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }]
            },
            options: [

            ],
            shopOptions: [

            ],
            overFlowHidiFlag: false,
            momentStamp: momentStamp,
            // 新增楼层地图翻页查询
            mappamrs: {
                page: 1,
                pageSize: 12,
                limit: true
            },
            shoppars: {
                page: 1,
                pageSize: 12,
                limit: true
            },
            mapcolse:'',
            canvaswidth:0,
            canvasheight:0,
            canvasboxwidth:780,
            canvasboxheight:660,
            boxmaps:false,
            boxmapfntrue() {
              state.boxmaps = true
            },
            boxmapfnfalse() {
              state.boxmaps = false
            },
            colsemaps() { //关闭地图弹窗时候触发再次查询地图列表~
                    // state.getbuildmaps()
                    // state.getshopmaps()
                    state.mapVisible = false
                    state.detailshoplist = []
                    if (state.mapcolse == '1') {
                       state.getshopmaps()
                    } else if (state.mapcolse == '2') {
                       state.getbuildmaps()
                    }
            },
            shophandleCurrentChange(page) {
                state.shoppars.page = page;
                state.getshopmaps();
            },
            shophandleSizeChange(pagesize) {
                state.shoppars.page = 1;
                state.shoppars.pageSize = pagesize;
                state.getshopmaps();
            },
            buildhandleCurrentChange(page) {
                state.mappamrs.page = page;
                state.getbuildmaps()
            },
            buildhandleSizeChange(pagesize) {
                state.mappamrs.page = 1;
                state.mappamrs.pageSize = pagesize;
                state.getbuildmaps()
            },

            getshopmaps() {
                let shoppamr = {
                    shop: state.onClickData.id
                }
                shoppamr = Object.assign(shoppamr, state.shoppars)
                getshopmaplists(shoppamr).then(res => {
                console.log('查询地图列表',res)

                    if (res.code == 200) {
                        state.detailshoplist = res.data.list
                        state.total = res.data.total
                    } else {
                        state.detailshoplist = []
                    }
                })
            },
            getbuildmaps() {
                let mapobj = {
                    floor: state.recordroomid,
                }
                mapobj = Object.assign(mapobj, state.mappamrs)
                getmaplists(mapobj).then(res => {
                    console.log('楼层地图查询',res)
                    state.mapfalge = true
                    if (res.code == 200) {
                        state.detailmapinfo = res.data.list
                        state.total = res.data.total
                    } else {
                        state.detailmapinfo = []
                        state.mapinfos = ''
                    }
                })
            },
            jump(data) {
                // sessionStorage.setItem('robotData', JSON.stringify(data))
                // router.push({ path: '/robot/robotList', query: data })
                router.push({ name: 'robot', params: data })
            },
            visibilityChange(event) {
                const ev = event.target;
                const ev_weight = ev.offsetWidth;
                if (ev_weight > 150) {
                    state.overFlowHidiFlag = true
                } else {
                    state.overFlowHidiFlag = false
                }
            },
            updateBui() {
                if (!state.updateData) {
                    return
                } else {
                    state.buildingOpen = true
                }
            },
            updateBuiCope() {
                if (!state.updateData) {
                    return
                } else {
                    state.shopOpen = true
                }
            },
            // 楼栋 店铺切换
            shopSelect(val) {
                // state.shop_building_Flag = val
                localStorage.setItem('shop_building_Flag', val)
            },
            buildingsChage(){
                state.buidingDialogForm.name = state.buidingDialogForm.name.trim()
            },
            buildingsInput(){
                // state.buidingDialogForm.name = inputRules(state.buidingDialogForm.name)
                state.buidingDialogForm.name = inputLengthLimit(state.buidingDialogForm.name,20)
            },
            // 点击设置参数并且打开
            setmapinfo(ele) {
                state.mapinfos = ele
                localStorage.removeItem('boxmapshow')
                state.mapVisible = true
            },
            // 页码切换
            changePage(val) {
                state.params.page = val
                state.robotsListQuery()
            },
            // 楼宇楼层弹窗关闭
            buidingDialogClose() {
                state.buidingDialog = false
            },
            setdetatils(detail) {
                state.deletemapflage = false
                state.detatildata = {}
                if (detail === 'mapsucces') {
                    state.getbuildmaps()
                } else if (detail == 'shopmapsucces') {
                    state.getshopmaps()
                }
            },
            Deletemapbtn(data, url, mode) {
                state.detatildata.id = data
                state.detatildata['distinction'] = url
                state.detatildata['modetext'] = mode
                state.deletemapflage = true
            },
            getData() {
                state.treeData = []
                let params = {
                    name: '',
                    pageSize: '',
                    page: '',
                    limit: false
                }

                // 查完楼宇再查店铺
                buildingListRequest(params).then((res) => {

                    res.data.list.map(el => {
                        el.label = el.name
                        el.buildingFlag = true
                        el.buildingActive = false
                        state.treeData.push(el)
                    });

                    // 店铺查询
                    shopQuery().then((res) => {
                        res.data.map(el => {
                            el.shopFlag = true
                            el.shopChecked = false
                            state.treeData.push(el)
                        });
                        // 默认选中（代码重复之后优化）
                        state.current_id = state.treeData[0].id
                        state.treeData[0].buildingActive = true

                        // 有数据
                        if(state.treeData){
                            state.notDataFlag = 'building'
                        }

                        if (state.treeData[0].buildingFlag) {
                            buildingFloorRequest({ building_id: state.current_id }).then(res => {

                                state.floorLists = res.data.list
                                // 没有楼层return出去
                                if (res.data.list == null) {
                                    return
                                }
                                state.treeData.map(item => {
                                    if (!item.children) {
                                        state.treeData[0].children = []
                                    } else {
                                        return
                                    }
                                    res.data.list.forEach(el => {
                                        el.label = el.name
                                        el.floorFlag = true
                                        state.treeData[0].children.push(el)
                                    });
                                })
                                
                            })
                        }

                    })


                })
            },
            // 选中节点触发
            handleNodeClick(currentData, attribute, fn) {
                console.log('选中节点触发')
                state.updateActiveFlag = false // 取消更换楼宇选中
                state.onClickData = currentData
                if (currentData.buildingFlag) {
                    // 选中楼宇换图
                    state.treeData.forEach((item) => {
                        if (item.id == currentData.id) {
                            item.buildingActive = true
                        } else {
                            item.buildingActive = false
                            item.shopChecked = false
                        }
                    })

                    state.notDataFlag = 'building'
                    state.buildingSelect = true
                    state.shopActive = false
                    state.robotsListQuery()
                } else if (currentData.shopFlag) {
                    // 选中店铺换图
                    state.treeData.forEach((item) => {
                        if (item.id == currentData.id) {
                            item.shopChecked = true
                        } else {
                            item.buildingActive = false
                            item.shopChecked = false
                        }
                    })
                    state.notDataFlag = 'shop'
                    state.activeNameShop = 'shopRobot'
                    state.buildingSelect = false
                    state.shopActive = true
                    state.robotsListQuery()
                } else if (currentData.floorFlag) {
                    state.notDataFlag = 'floor'
                } else {
                    state.notDataFlag = null
                }
                state.buildingQuery(currentData)
            },
            // 查询地图列表
            robotsListQuery() {
                // 重复点击return出去
                if(state.notRepeatedClicks == state.onClickData.id){
                    return
                }
                state.recordroomid = ''
                state.notRepeatedClicks = state.onClickData.id
                // 查询店铺关联的机器人
                if (state.onClickData.shopFlag) {
                    state.detailshoplist = []
                    state.mapcolse = '1'
                    state.getshopmaps()
                } else if (state.onClickData.buildingFlag) {
                    return
                }

            },
            // 查询楼层
            buildingQuery(currentData, targetValue) {
                // 点击楼层不发接口查询
                state.mapfalge = false
                if (currentData.floorFlag) {
                    // state.detailmapinfo = currentData.id 
                    if (state.recordroomid == currentData.id) {
                        return
                    }
                    state.notRepeatedClicks = ''
                    state.recordroomid = currentData.id
                    state.detailmapinfo = []
                    state.mapinfos = []
                    state.mapcolse = '2'
                    state.getbuildmaps()
                    return
                }
                // 点击店铺不发楼层接口查询
                if (currentData.shopFlag) {
                    return
                }
                let params = {
                    building_id: currentData.id,
                    name: '',
                    pageSize: '',
                    page: '',
                    limit: false
                }
                buildingFloorRequest(params).then(res => {
                    state.floorLists = res.data.list
                    // 没有楼层return出去
                    if (res.data.list == null) {
                        return
                    }
                    state.treeData.map(item => {
                        console.log('22',res.data.list)
                        if (currentData.buildingFlag && currentData.id == res.data.list[0].building_id) {

                            currentData.children = []
                             
                            res.data.list.forEach(el => {
                                el.label = el.name
                                el.floorFlag = true
                                currentData.children.push(el)
                            });
                        }
                    })
                })
            },
            // 添加楼宇
            buildingAppend() {
                state.confirmFlag = 'add'
                // 选中上次选项
                // state.buidingDialogForm.selectValue = localStorage.getItem('shop_building_Flag')
                // 默认选中店铺
                state.buidingDialogForm.selectValue = '1'
                state.addBuildingFlag = true

                // 给input赋空
                state.buidingDialogForm.name = ''
                state.buidingDialogForm.id = 1
                state.buidingDialogTitle = _t('buiding.buildingAdd')
                state.addEditHolder = _t('buiding.pleaseBuilsdingName')
                state.inputNumberFlag = false
                state.orderNumberFlag = false
                state.buidingDialog = true
            },
            // 添加楼层
            append(data) {
                state.buidingDialogForm.selectValue = '' // 添加楼层 添加楼栋店铺赋值为空（不为空会影响后面添加楼栋、店铺判断）
                state.onClickData = data
                state.confirmFlag = 'add'
                state.addBuildingFlag = false
                // 给input赋空
                state.buidingDialogForm.name = ''
                state.buidingDialogForm.id = 1
                state.buidingDialogTitle = _t('buiding.addFloors')
                state.inputLabel = _t('buiding.floorName')
                state.addEditHolder = _t('buiding.new-pleaseFloorName')
                state.nullTips = _t('buiding.floorNameBeEmpty')
                state.editNameChange = 'floorName' // 这里有点逻辑混乱     这是添加楼层校验的名字
                state.inputNumberFlag = true
                state.orderNumberFlag = true
                state.buidingDialog = true
            },
            remove(node, data) {

                if (data.floorFlag) {
                    state.dialogMessage = _t('buiding.AreYouSureToDeleteThisFloor')
                    state.dialogTtile = _t('buiding.deleteFloor')
                } else if (data.shopFlag) {
                    state.dialogMessage = _t('buiding.AreYouSureToDeleteThisShop')
                    state.dialogTtile = _t('buiding.deleteShop')
                } else {
                    state.dialogMessage = _t('buiding.AreYouSureToDeleteThisBuilding')
                    state.dialogTtile = _t('buiding.deleteBuilding')
                }
                state.dialogOpen = true
                state.removeNode = node
                state.removeData = data
            },
            // 编辑
            edit(node, data) {
                state.buidingDialogForm.selectValue = '' // 添加楼层 添加楼栋店铺赋值为空（不为空会影响后面添加楼栋、店铺判断）
                state.confirmFlag = 'edit'
                state.editNode = node
                state.editData = data
                state.orderNumberFlag = true
                state.addBuildingFlag = false
                if (data.buildingFlag) {
                    state.buidingDialogTitle = _t('buiding.editBuilding')
                    state.inputLabel = _t('buiding.buildingName')
                    state.inputNumberFlag = false
                    state.editNameChange = 'buildingEidt'
                }
                if (data.floorFlag) {
                    state.buidingDialogTitle = _t('buiding.editFloor')
                    state.inputLabel = _t('buiding.floorName')
                    state.inputNumberFlag = true
                    state.editNameChange = 'floorEidt'
                }
                if (data.shopFlag) {
                    state.buidingDialogTitle = _t('buiding.editShop')
                    state.inputLabel = _t('buiding.shopName')
                    state.inputNumberFlag = false
                    state.editNameChange = 'shopEidt'
                }
                state.buidingDialogForm.name = data.name
                state.buidingDialogForm.id = data.index
                state.buidingDialog = true
            },
            addAndEdit() {
                if (state.buidingDialogForm.selectValue == '1') {
                    // 添加店铺
                    let params = {
                        name: state.buidingDialogForm.name
                    }
                    shopAdd(params).then((res) => {
                        if (res.code != 200) {
                            if (res.code == '10001' || res.code == '80001') {
                                ElMessage.error(_t('buiding.shopNameAlreadyExists'))
                                return
                            }
                            ElMessage.error(`${res.msg}`)
                        } else {
                            ElMessage({
                                message: _t('buiding.shopAddSuccess'),
                                type: "success",
                            })
                            state.buidingDialog = false
                            state.getData()
                        }
                    })
                    return
                }
                if (state.confirmFlag == 'add') {
                    // 添加楼层
                    if (state.onClickData.buildingFlag && state.addBuildingFlag == false) {
                        let params = {
                            floorName: state.buidingDialogForm.name,
                            index: Number(state.buidingDialogForm.id)
                        }
                        buildingFloorAdd(params, state.onClickData.id).then(res => {
                            if (res.code != 200) {
                                if (res.code == '10001') {
                                    ElMessage.error(_t('buiding.sameFloorNumber'))
                                    return
                                }
                                ElMessage.error(`${res.msg}`)
                            } else {
                                ElMessage({
                                    message: _t('buiding.floorAddSuccess'),
                                    type: "success",
                                })
                                state.buildingQuery(state.onClickData, res)
                            }
                            state.buidingDialog = false
                        })
                        return
                    } else {
                        // 添加楼宇
                        let params = {
                            name: state.buidingDialogForm.name
                        }
                        buildingAdd(params).then(res => {
                            if (res.code != 200) {
                                if (res.code == '10001') {
                                    ElMessage.error(_t('buiding.buildingNameAlreadyExists'))
                                    return
                                }
                                ElMessage.error(`${res.msg}`)
                            } else {
                                ElMessage({
                                    message: _t('buiding.buildingAddSuccess'),
                                    type: "success",
                                })
                                state.getData()
                            }
                            state.buidingDialog = false
                            return
                        })
                    }
                } else {
                    // 更新店铺
                    if (state.editData.shopFlag) {
                        let params = {
                            name: state.buidingDialogForm.name,
                            id: state.editData.id
                        }
                        shopUpdate(params).then(res => {
                            if (res.code != 200) {
                                if (res.code == '10001') {
                                    ElMessage.error(_t('buiding.shopNameAlreadyExists'))
                                } else {
                                    ElMessage.error(`${res.msg}`)
                                }
                            } else {
                                ElMessage({
                                    message: _t('buiding.shopEditSuccess'),
                                    type: "success",
                                })
                                state.getData()
                            }
                            state.buidingDialog = false
                        }).catch(err => {

                        })
                    }

                    // 更新楼宇 
                    if (state.editData.buildingFlag) {
                        let params = {
                            name: state.buidingDialogForm.name
                        }
                        buildingPut(params, state.editData.id).then(res => {
                            if (res.code != 200) {
                                if (res.code == '10001') {
                                    ElMessage.error(_t('buiding.builNameAlreadyExists'))
                                } else {
                                    ElMessage.error(`${res.msg}`)
                                }
                            } else {
                                ElMessage({
                                    message: _t('buiding.buildingEditSuccess'),
                                    type: "success",
                                })
                                state.getData()
                            }
                            state.buidingDialog = false
                        }).catch(err => {

                        })
                    }
                    // 更新楼层
                    else {
                        let params = {
                            floorName: state.buidingDialogForm.name,
                            index: state.buidingDialogForm.id
                        }
                        buildingFloorPut(params, state.editData.building_id, state.editData.id).then(res => {
                            if (res.code != 200) {
                                if (res.code == '10001') {
                                    ElMessage.error(_t('buiding.floorNameAlreadyExists'))
                                } else {
                                    ElMessage.error(`${res.msg}`)
                                }
                            } else {
                                ElMessage({
                                    message: _t('buiding.floorEditSuccess'),
                                    type: "success",
                                })
                                state.buildingQuery(state.editNode.parent.data, '')
                            }
                            state.buidingDialog = false
                        }).catch(err => {

                        })
                    }
                }

            },
            editNo() {
                if (state.addData) {
                    // 用户取消添加
                    state.addData.pop() // 删除最后一个元素
                } else {
                    // 用户取消编辑
                    state.editData.show = false
                }
                state.maskOpen = false
            },
            shopClose() {
                state.dialogShop = false
            },
            handleClose() {
                state.dialogRobot = false
            },
            // 关联机器人
            relationRobot(str) {
                // 关联机器人
                if (str == 'relation') {
                    state.upadteContentFlag = false
                    state.relationDialogFlag = true
                    state.dialogRobot = true
                    state.selectTipsFlag = true
                    state.placeholderS = _t('buiding.selectRobot')
                } else {
                    // 更换楼宇
                    // 没有选中就return出去
                    if (!state.updateData) {
                        return
                    }
                    state.upadteContentFlag = true
                    state.relationDialogFlag = false
                    state.dialogRobot = true
                    state.selectTipsFlag = false
                    state.dialogRobotTitle = _t('buiding.replacementBuildings')
                    state.placeholderS = _t('account.selectbuild')
                }
                // 机器人列表查询
                buildingRobotsAll().then(res => {
                    res.data.forEach(item => {
                        if (item.building_id > 0 || item.shop_id > 0) {
                            item.disabled = true
                        }
                    })
                    state.options = res.data
                })

            },
            // 关联店铺 更换店铺
            shopRelationRobot(str) {
                // 关联机器人
                if (str == 'shopRelation') {
                    state.relationShop = true
                    state.upadteShopFlag = false
                    state.dialogShop = true
                } else {
                    // 更换楼宇
                    // 没有选中就return出去
                    if (!state.updateData) {
                        return
                    }
                    state.dialogShop = true
                    state.relationShop = false
                    state.upadteShopFlag = true
                }
                // 机器人列表查询
                buildingRobotsAll().then(res => {
                    res.data.forEach(item => {
                        if (item.shop_id > 0 || item.building_id > 0) {
                            item.disabled = true
                        }
                    })
                    state.shopOptions = res.data

                })

            },
            buildingOff() {
                state.buildingOpen = false
            },
            shopOff() {
                state.shopOpen = false
            },
            OFF() {
                state.dialogOpen = false
            },
            ON() {
                state.dialogOpen = false
                let params = {
                    id: state.removeData.id
                }
                // 删除店铺
                if (state.removeData.shopFlag) {
                    let data = {
                        id: state.removeData.id
                    }
                    shopDelete(data).then(res => {

                        if (res.code == 10013 || res.code == 10014||res.code == 10016) {
                            ElMessage.error(_t('buiding.deleteShopTips'))
                            return
                        }
                        state.getData()
                    })
                    return
                }
                // 删除楼宇 
                else if (state.removeData.buildingFlag) {

                    buildingDelete(params).then(res => {

                        if (res.code == 10013 || res.code == 10014) {
                            ElMessage.error(_t('buiding.deleteBuidingTips'))
                            return
                        }
                        const parent = state.removeNode.parent
                        const children = parent.data || parent.data
                        // const index = children.findIndex((d) => d.id === state.removeData.id)
                        children.map((el, index) => {
                            if (el.id == state.removeData.id) (
                                children.splice(index, 1)
                            )
                        })
                    })
                }
                // 删除楼层
                else {
                    buildingFloorDelete(params).then(res => {

                        if (res.code == 10015 || res.code == 10016) {
                            ElMessage.error(_t('buiding.deleteFloorTips'))
                            return
                        }
                        const parent = state.removeNode.parent
                        const children = parent.data || parent.data
                        // const index = children.findIndex((d) => d.id === state.removeData.id)
                        children.children.map((el, index) => {
                            if (el.id == state.removeData.id) (
                                children.children.splice(index, 1)
                            )
                        })
                    })
                }

            },

            // 关联机器人选择器 
            selcetChange(val) {

                state.numbers = ''
                val.forEach(item => {
                    state.numbers += item + ','
                })
                state.relationParams.robots = state.numbers
                state.relationParams.building_id = state.onClickData.id
            },
            robotChange(val) {

                state.numbers = ''
                val.forEach(item => {
                    state.numbers += item + ','
                })
                state.shopRelationParams.robots = state.numbers
                state.shopRelationParams.shop_id = state.onClickData.id
            },
            // 更新楼宇选择器 
            singleSelcetChange(val) {

                state.relationParams.building_id = state.onClickData.id

            },
            // 更新店铺选择器
            shopChange(val) {

                state.shopRelationParams.shop_id = val
            },
            checkChange(val) {

                state.updateData = ''
                state.relationListArr.forEach(item => {
                    if (item.checkedFlag) {
                        state.updateData += item.id + ','
                    }
                })

                // 按钮是否置灰
                if (state.updateData) {
                    state.updateActiveFlag = true
                } else {
                    state.updateActiveFlag = false
                }
                state.relationParams.robots = state.updateData
                state.shopRelationParams.robots = state.updateData
            },
            getbuildingContentwidth(){
                 nextTick(()=>{
                    // console.log(buildingContent.value.clientWidth,'width',document.documentElement.clientWidth)
                    state.canvaswidth = buildingContent.value.clientWidth
                    state.canvasheight = buildingContent.value.clientHeight - 20
                    state.canvasboxwidth = document.documentElement.clientWidth
                    state.canvasboxheight = document.documentElement.clientHeight
                 })
            }
        })
        const buildingContent = ref()
        onMounted(() => {
            state.getData()

            // ... 适配
            window.onresize = () => {
                state.width = document.body.clientWidth;
                if (Number(state.width) <= 1529) {
                    state.span4_1528 = true
                    state.span4_1272 = false
                }
                if (Number(state.width) <= 1273) {
                    state.span4_1272 = true
                    state.span4_1528 = false
                }
                if (Number(state.width) >= 1920) {
                    state.span4_1272 = false
                    state.span4_1528 = false
                }
                return state.width
            }
            state.getbuildingContentwidth()
            window.addEventListener('resize',state.getbuildingContentwidth)
        })

        onUnmounted(() => {
            window.onresize = null
        })

        return {
            ...toRefs(state),
            moment,
            inpt,
            buildingContent
        }
    }
})
</script>

<style lang="scss" >
.buildingPage {
    .demo-tabs .el-tabs__item {
  font-size: 16px;
  font-weight: 600;
}
    .box-item {
        position: absolute;
    }

    .el-dialog__header,
    .el-dialog__footer {
        position: relative;
    }

    .el-dialog__footer::before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        transform-origin: 0 0;
    }

    .select-tips {
        text-align: center;
        margin-bottom: 20px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
    }

    .select-box {
        display: flex;
        justify-content: center;
        margin-right: 53px;

    }

    .inputWidth {
        .el-form-item--medium .el-form-item__label{
            min-width: 165px;
        }
        .el-input--medium .el-input__inner {
            width: 300px;
            
        }
        .el-input-number--medium{
            width: 300px;
        }
    }

    // 分页
    .el-pagination.is-background .btn-next, 
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
    }

    .el-tabs__header {
        margin-right: 20px;
    }


    .el-tree-node__content {
        width: 100%;

        .custom-tree-node {
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            .frontPic {
                width: 14px;
                height: 14px;
                position: relative;
                top: 2px;
                margin-right: 10px;
            }
        }
    }

    .el-tree-node__content {
        height: 35px;
    }

    /* 点击树结构项的选中颜色 */

    .el-tree-node__content:hover {
        background-color: #E6F8FF;

    }

    .el-tree-node.is-current>.el-tree-node__content {
        background-color: #E6F8FF;
    }

    .el-tree-node.is-current>.el-tree-node__content .custom-tree-node {
        color: #409eff;
    }
}

.buildingPage .buildingRight-title .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content .spanColor {
    color: #409eff; //节点的字体颜色
}

// 弹出框
.el-popover.popperClass {
    min-width: 50px !important;
    text-align: center;
}
</style>
<style lang="scss" scoped>
// 不显示滚动条
body::-webkit-scrollbar {
    width: 0;
}

// 机器人弹窗
p {
    margin: 0;
    padding: 0;
}

.buildingPage {
    display: flex;
    margin: 20px 0 20px 20px;
    height: 840px;
    overflow: auto;
}

// 划入显示
.el-tree-node__content:hover .solt-center {
    opacity: 1;
}

// 点击显示
.el-tree-node__content:focus .solt-center {
    opacity: 1;
}
.newmapclass{
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #D6E8F9;
}
.newboxmapclass{
   position: fixed;
    z-index: 99999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #D6E8F9; 
}
.buildingRight {
    width: 400px;
    height: 100%;
    background: #FFFFFF;
    margin-right: 24px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.mask {
    position: absolute;
    width: 400px;
    height: 100%;

    background: rgba(0, 0, 0, 0);
    z-index: 200;
}

.buildingRight-title {
    position: relative;
    box-sizing: border-box;
    padding: 0 0 0 20px;
    width: 400px;
    background: #FFFFFF;

    .buildlists {
        display: flex;
        justify-content: space-between;
        height: 50px;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

    }

    div {
        font-size: 14px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
    }

    .buildingAdd {
        height: 32px;
        background: #1890FF;
        border-radius: 2px;
        margin-right: 20px;
        padding: 0 10px;
        cursor: pointer;
        background: #1890FF;
        line-height: 32px;
        display: flex;

        div {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 10px;
        }

        .addrolesspan {
            margin-left: 0px;
            position: relative;
            width: 16px;
            height: 32px;

            .addroles {
                position: absolute;
                left: 0;
                top: 8px;
                color: #fff;
            }
        }
    }

    .custom-tree-node {

        input,
        .yes-error {
            position: relative;
            z-index: 300;
        }
    }
}


.buildingContent {
    position: relative;
    width: 73%;
    background: #FFFFFF;
    padding: 20px 0 20px 20px;

    .relationRobot {
        height: 740px;
        overflow-y: scroll;
    }

    .relationRobot-title {
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
    }

    .relationRobot-title .right-box {
        display: flex;
    }

    .relationRobot-title .right-relation {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 116px;
        height: 32px;
        background: #1890FF;
        border-radius: 2px;
        margin-right: 20px;
        cursor: pointer;

        .addroles {
            color: #fff;
        }

        span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 10px;
        }
    }

    .relationRobotList {
        margin-top: 20px;
        height: 634px;
        overflow: auto;

        .robotBoxActive {
            border: 2px solid #1890FF;
        }

        .robotBox {
            float: left;
            display: block;
            width: 312px;
            height: 200px;
            background: #FFFFFF;
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            margin-top: 1px;
            margin-left: 2px;
            margin-right: 22px;
            margin-bottom: 30px;

            .robotBox-left {
                position: relative;
                float: left;
                margin-right: 20px;

                .el-checkbox__inner {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                }

                img {
                    width: 120px;
                    height: 200px;
                }
            }

            .robotBox-right {
                margin-top: 15px;

                .robotBox-right-head {

                    div {
                        display: inline-block;
                        background: rgba(82, 196, 26, 0.15);
                        border-radius: 2px;
                        border: 1px solid #52C41A;
                        min-width: 36px;
                        height: 22px;
                        margin-right: 20px;

                        span {
                            margin: 5px;
                            font-size: 10px;
                            height: 18px;
                            line-height: 18px;
                            color: #52C41A;
                        }
                    }
                }

                .robotBox-right-content {
                    margin: 20px 0;

                    p {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.85);
                    }
                }

                .batterbagrdbox {
                    width: 13px;
                    height: 8px;
                    position: relative;
                    left: 142px;

                    .batteryText {
                        position: absolute;
                        left: 18px;
                        top: -4px;
                        font-size: 12px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.85);
                    }

                    .batteryBagrd {
                        position: absolute;
                        height: 100%;
                        width: 0%;
                        display: flex;

                        .battersimg {
                            margin-left: -1px;
                            width: 16px;
                            height: 8px;
                        }

                        .absoluteimg {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            width: 8px;
                            height: 8px;
                        }
                    }
                }


                .robotBox-right-foot {
                    margin-top: 20px;

                    p {
                        height: 20px;
                        font-size: 12px;
                        color: rgba(0, 0, 0, 0.45);
                    }
                }

            }

        }

    }

    .rightUpadta {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 88px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px;
        opacity: 0.3;
        border: 1px solid #D9D9D9;
        cursor: pointer;

        span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
        }
    }

    .updateActive {
        background: #1890FF;
        opacity: 1;
        border: none;

        span {
            color: #FFFFFF;
        }
    }

    .noContent {
        min-height: 700px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            display: block;
            width: 293px;
            height: 225px;
            margin-bottom: 30px;
        }

        div {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
        }
    }

    .mapinfo {
        .title {}

        .message {
            margin: 16px 0;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            position: relative;

            span {
                color: rgba(0, 0, 0, 0.85)
            }

            span:nth-child(2) {
                margin-left: 90px;
            }


            .deletebtn:hover {
                background: rgba(239, 14, 14, 0.05);
            }
        }
    }

    .notData {
        img {
            display: block;
            width: 40px;
            height: 40px;
            margin-bottom: 10px;
        }

        .addRobot {
            margin-top: 6px;
        }
    }
}
.cardmap{
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
}
.cardBox {
    flex:  0 0 33%;
    padding: 20px 0;
    vertical-align: top;
    cursor: pointer;

    .oneCard {
        width: 90%;
        min-width: 312px;
        margin: 0 auto;
        box-shadow: 2px 4px 5px 0px rgba(0, 21, 41, 0.12), -2px 0px 5px 0px rgba(0, 21, 41, 0.12);
        border-radius: 4px;
        background: #fff;
        position: relative;
        padding: 2px;

        .robotsn {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
        }
    }

    .oneCard:hover {
        padding: 0;
        border: 2px solid #1890FF;
    }

    .card-header {
        font-size: 16px;
        font-weight: bold;
        padding: 10px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .mapName {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            word-break: break-all;
        }

        .deletebtn {
            font-size: 14px;
            color: #F5222D;
            border-radius: 2px;
            cursor: pointer;
        }
    }

    .card-body {
        padding: 0 20px 5px 20px;

        .textdiv {
            margin: 5px 0;
            color: rgba(0, 0, 0, 0.45);
            font-size: 12px;
        }
    }

    .card-footer {
        padding: 0 0 10px 0;
        width: 100%;

        img {
            width: 90%;
            height: 150px;
            margin-left: 5%;
        }
    }
}

// 分页
.paging {
    position: absolute;
    right: 20px;
    top: 5px;
}

.qwd {
    width: 100%;
    height: 40px;
    position: relative;
}

.el-tree-node__content {
    position: relative;
}

.solt-center {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    vertical-align: middle;
    opacity: 0;

    span {
        position: absolute;
        right: 0;
    }

    .span4 {
        right: 6%;
    }

    .span4_1528_style {
        right: 12% !important;
    }

    .span4_1272_style {
        right: 18% !important;
    }

    .span3 {
        right: 15%;
    }

    .span2 {
        right: 24%;
    }

    .spanAdd {
        right: 6%;
    }

    // 机器人、地图图标 特殊处理
    .span1 {
        position: absolute;
        left: 220px;

        .mapIcon {
            margin-left: 20px;
        }
    }

    .span-num {
        position: absolute;
        left: 15px;
        top: -1.5px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
    }

    .mapNum {
        left: 55px;
    }
}


.yes-error {
    vertical-align: middle;

    span {
        margin-left: 20px;
    }
}
</style>